import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react";
import type { CSSProperties } from "react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

// No theme-switcher dependency (next-themes) — v1 has no light/dark toggle UI; "system" lets
// Sonner follow prefers-color-scheme on its own, matching the token layer's :root/.dark split.
//
// CRAFT.md §5 Feedback: bottom-right, 4s, one at a time (queue, don't stack). visibleToasts=1
// is what makes Sonner queue rather than pile — a second toast waits for the first to clear
// instead of stacking beside it. These are defaults, not overrides: {...props} comes last so a
// caller COULD override, but the single mount site (app root) never does.
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="system"
      position="bottom-right"
      duration={4000}
      visibleToasts={1}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: "cn-toast",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
